const getHotelItinerariesByPaymentType = (trip, paymentTypeCode = undefined) => {
  if (!trip || !trip.hotelItineraries || Object.keys(trip.hotelItineraries).length === 0) {
    return [];
  }

  const hotelArray = Array.isArray(trip.hotelItineraries)
    ? trip.hotelItineraries
    : Object.values(trip.hotelItineraries);

  if (paymentTypeCode === undefined || paymentTypeCode === null) {
    return hotelArray.filter(
      (hotelItinerary) =>
        hotelItinerary?.selectedProduct && !hotelItinerary.selectedProduct.isPrepaidRate,
    );
  }

  return hotelArray.filter(
    (hotelItinerary) =>
      hotelItinerary?.selectedProduct &&
      hotelItinerary.selectedProduct.paymentTypeCode === paymentTypeCode &&
      !hotelItinerary.selectedProduct.isPrepaidRate,
  );
};

export default getHotelItinerariesByPaymentType;
